import { Component, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { Modalable } from "@app/Modalable"

@Component({
	selector: "app-privacy",
	imports: [COMMON_IMPORTS],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div
			style="padding: 50px 3%; font-size: 16px"
			dir="rtl"
		>
			<div
				align="center"
				class="pb-3"
			>
				<strong><u>מדיניות פרטיות - </u></strong>
				<strong><u>My-Cliniq</u></strong>
				<strong><u></u></strong>
			</div>
			<div>
				<strong>ד"ר עמי אבני בע"מ ח.פ. 513350728</strong> ("החברה") מודה לכם על
				בחירתכם להשתמש באתר ובמערכת My-Cliniq ("האפליקציה" ו/או "האתר" ו/או
				"המערכת"). החברה מכבדת את פרטיות הלקוחות והמשתמשים באתר ובמערכת, ורואה
				חשיבות רבה בשמירה עליה. מדיניות הפרטיות להלן מהווה חלק בלתי נפרד מהתקנון
				ותנאי השימוש.
			</div>
			<div
				dir="ltr"
				class="py-3"
			>
				דצמבר 2025
			</div>
			<ol>
				<li style="font-weight: 400">
					<strong>המידע הנאסף באתר ובמערכת</strong><strong>:</strong
					><span style="font-weight: 400">&nbsp;</span>
				</li>
				<ol>
					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>בעת השארת פרטים באתר ו/או במערכת יתבקש המשתמש</span
						>
						<span style="font-weight: 400"
							>למסור פרטים אישיים כגון: שם פרטי, שם משפחה, כתובת אימייל, מספר
							טלפון, סיסמה</span
						><span style="font-weight: 400">&nbsp; </span
						><span style="font-weight: 400">וכדו' (לשיקול דעת החברה</span
						><span style="font-weight: 400">). </span
						><span style="font-weight: 400"
							>המידע אותו הנך מוסר בעת הרשמתך, באתר או/ו במערכת נאסף על ידי האתר
							והמערכת.&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>מובהר כי אין חובה על-פי חוק למסור את המידע, אולם בלא למוסרו לא
							ניתן יהיה לבצע שימוש במערכת</span
						><span style="font-weight: 400">.&nbsp;</span>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>על מנת לספק שירות איכותי, בנוסף למידע אותו הנך מוסר בעת הרשמתך
							ו/או באתר ו/או במערכת, האתר והמערכת אוספים מידע מסוים אודות המחשב
							שלך ו/או המכשיר שלך, אשר באמצעותו הנך מבקר ומבצע פעולות באתר ו/או
							במערכת.&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>המידע נאסף באופן אוטומטי (לרבות באמצעות שימוש ב "Cookies") והוא
							עשוי לכלול כתובות IP, סוג דפדפן, זמני גלישה וכניסה לאתר ו/או
							למערכת, אופן הגלישה והכלי בו הנך משתמש למטרת הגלישה, פרטים לגבי
							ספק האינטרנט שלך וכתובות אתרי האינטרנט מהם הגעת. (המידע הנמסר בעת
							ההרשמה&nbsp; והמידע הנאסף על ידי האתר והמערכת כאמור בסעיף 1 שלעיל
							יכונו יחד: "</span
						><strong>המידע הנאסף באתר ובמערכת</strong
						><span style="font-weight: 400">").&nbsp;&nbsp;</span>
					</li>
				</ol>

				<li
					style="font-weight: 400"
					class="pt-3"
				>
					<strong>שימוש במידע הנאסף באתר ובמערכת</strong><strong>:</strong
					><span style="font-weight: 400">&nbsp;</span>
				</li>

				<ol>
					<li style="font-weight: 400">
						<span style="font-weight: 400">האתר ו/או המערכת</span>
						<span style="font-weight: 400"
							>ו/או מי מטעמם רשאים לעשות שימוש במידע הנאסף באתר ובמערכת, בין
							היתר, למטרות הבאות:&nbsp;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>בכדי לספק לך את המידע שביקשת או מידע נוסף אשר אנו מאמינים שהוא
							עשוי לעניין אותך, מעת לעת;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>בכדי להתאים את השימוש במערכת על פי העדפותיך האישיות;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>לספק לך שירותים ולשפר את האתר והמערכת ו/או את
							השירותים;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>לשם תפעולם התקין של האתר והמערכת;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>לנתח את המידע ולנהל את האתר והמערכת באופן תקין;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>שיפור שירות הלקוחות של האתר והמערכת;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>בכדי לבצע סקרי לקוחות ו/או מחקרי שיווק אשר האתר והמערכת</span
						>
						<span style="font-weight: 400">עורכים מעת לעת.&nbsp;&nbsp;</span>
					</li>
				</ol>

				<li
					style="font-weight: 400"
					class="pt-3"
				>
					<strong>העברת המידע הנאסף באתר ו/או במערכת</strong>
					<strong>לצדדים שלישיים</strong><strong>:</strong
					><span style="font-weight: 400">&nbsp;</span>
				</li>

				<ol>
					<li style="font-weight: 400">
						<span style="font-weight: 400">האתר, המערכת</span>
						<span style="font-weight: 400"
							>ו/או מי מטעמה לא יגלו ו/או ימכרו כל מידע הנאסף באתר ו/או במערכת
							לכל צד שלישי כלשהו, וזאת למעט למי מטעמם להם הם מספקים את המידע
							הנאסף באתר ו/או במערכת&nbsp; אך ורק לצורך מתן שירות באתר ו/או
							במערכת, , ואשר אף הם מחויבים להגנה מלאה על סודיות המידע הנאסף באתר
							ו/או במערכת.&nbsp;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400">יחד עם זאת, האתר, המערכת</span>
						<span style="font-weight: 400"
							>ו/או מי מטעמה יהיו רשאים להעביר מידע הנאסף באתר ו/או במערכת (למעט
							פרטי אשראי ומספרי תעודות זהות) לצדדים שלישיים בכל אחד מהמקרים
							הבאים:&nbsp;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>ניתנה לכך הסכמתך מראש ובכתב;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400">האתר, המערכת</span>
						<span style="font-weight: 400"
							>ו/או מי מטעמם נדרשים על פי חוק להעביר את המידע האמור, למשל, מכוח
							צו בית משפט;&nbsp;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>על מנת להגן על זכויותיהם המשפטיות והקנייניות של האתר, מערכת</span
						>
						<span style="font-weight: 400"
							>ו/או מי מטעמם בכל הנוגע למערכת;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>במקרה של מחלוקת משפטית בינך לבין האתר, מערכת</span
						>
						<span style="font-weight: 400"
							>ו/או מי מטעמם אשר תחייב חשיפת הפרטים;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>אם תפר את התקנון ותנאי השימוש או אם תבצע באמצעות האתר ו/או
							המערכת, או בקשר כלשהו עם האתר ו/או מערכת, פעולות מנוגדות או הנחזות
							כמנוגדות לדין, או כל ניסיון לבצע פעולות כאלה;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400">בכל מקרה שהאתר ו/או המערכת</span>
						<span style="font-weight: 400"
							>יסברו, כי מסירת המידע הנאסף נחוצה על מנת למנוע נזק חמור לגוף
							המשתמש או לרכושו או לגופו או לרכושו של צד שלישי;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400">אם האתר ו/או המערכת</span>
						<span style="font-weight: 400"
							>ימוזגו לתוך פעילות גוף אחר או אם האתר ו/או המערכת יעברו לבעלות
							תאגיד אחר ניתן יהיה להעביר לתאגיד החדש את המידע הקיים באתר ו/או
							במערכת, אבל רק במקרה שהתאגיד יתחייב לשמור על מדיניות פרטיות
							זו.&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>לצבור מידע על לקוחות ו/או משתמשים ולשפר את שירות הלקוחות. לאחר
							מכן, האתר ו/או המערכת</span
						>
						<span style="font-weight: 400"
							>עשויים לשתף מידע כאמור עם שותפי שיווק פוטנציאליים
							ומפרסמים;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400">כמו כן, האתר ו/או המערכת</span>
						<span style="font-weight: 400"
							>עשויים לשתף את המידע האישי שלך (למעט מידע רגיש כגון פרטי אשראי
							ומספרי תעודות זהות) עם צדדים שלישיים, כולל עם שותפיהם העסקיים
							ונותני שירותים.&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>דוגמאות לפעולות שנותני שירותים עשויים לבצע הכרוכים במידע
							שלך:&nbsp;</span
						>
					</li>
					<ol>
						<li style="font-weight: 400">
							<span style="font-weight: 400"
								>לפתח ולתחזק את האתר והמערכת;&nbsp;</span
							>
						</li>

						<li style="font-weight: 400">
							<span style="font-weight: 400"
								>מידע אישי, מידע המועבר לצרכים סטטיסטים אינו כולל פרטים
								מזהים;&nbsp;&nbsp;&nbsp;</span
							>
						</li>

						<li style="font-weight: 400">
							<span style="font-weight: 400"
								>לנותני שירותים ושותפים עסקיים כאמור ניתנת גישה לכל או לחלק
								מהמידע שלך, והם עשויים להשתמש&nbsp; ב"Cookies" או בטכנולוגיית
								איסוף אחרות.</span
							>
						</li>
					</ol>
				</ol>

				<li
					style="font-weight: 400"
					class="pt-3"
				>
					<strong>מאגר מידע:</strong
					><span style="font-weight: 400">&nbsp;</span>
				</li>
				<ol>
					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>כדי למנוע גישה לא מורשית למידע ולנתוני החברה, ועל מנת לשמור על
							המידע ולהבטיח את השימוש המורשה בו, החברה מיישמת נהלים פיזיים,
							אלקטרוניים וניהוליים סבירים ומתאימים לשמירת ולאבטחת המידע, והחברה
							הוסמכה</span
						>
						<span style="font-weight: 400"
							>לתקנים ISO 27001/27799 כמו כן, החברה מגבילה את הגישה למידע אישי
							ולמידע סודי כך שגישה כאמור תינתן רק לעובדים שמידע זה נחוץ להם
							לצורך תפעול המערכת והפעולות הניתנות לביצוע באמצעות המערכת. עם זאת,
							בשל מגבלות טכנולוגיות, החברה אינה מתחייבת כי המידע האישי שלך, וכל
							מידע אחר המועבר באופן אלקטרוני, יהיה חסין באופן מוחלט מפני גישה
							בלתי מורשית</span
						><span style="font-weight: 400">.&nbsp;&nbsp;</span>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>המידע שהחברה אוספת נשמר במאגר המידע. אנו מאחסנים מידע באתרים
							שונים ובשרתים, לרבות באתרים המבוססים על טכנולוגיית
							ענן.&nbsp;&nbsp;</span
						>
					</li>
				</ol>
				<li
					style="font-weight: 400"
					class="pt-3"
				>
					<strong>אבטחת מידע:</strong
					><span style="font-weight: 400">&nbsp;</span>
				</li>
				<ol>
					<li style="font-weight: 400">
						<span style="font-weight: 400">האתר והמערכת</span>
						<span style="font-weight: 400">
							נוקטים צעדים סבירים על מנת לסייע בהגנה על אבטחת הנתונים האישיים של
							המשתמשים. האתר והמערכת</span
						>
						<span style="font-weight: 400"
							>עושים מאמצים על מנת לאסוף את המידע ולאבטחו בהתאם למדיניות הפרטיות
							ולחוקים והתקנות החלים במדינת ישראל.&nbsp;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>חשוב לזכור שלא ניתן לערוב במאת האחוזים מפני פעילות עוינת ונחושה
							מצד גורמים זרים ולכן אין בפעולות אלה בטחון מוחלט והאתר
							והמערכת</span
						>
						<span style="font-weight: 400"
							>לא מתחייבים שהשירותים באתר ובמערכת יהיו חסינים באופן מוחלט מפני
							גישה בלתי מורשית למידע הנאסף בהם.&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>למשתמשי המערכת לא תהיה כל טענה ו/או דרישה ו/או תביעה כלפי החברה
							ו/או המערכת או מי מטעמם בגין גישה בלתי מורשית למידע שנאסף עליהם על
							ידי המערכת.&nbsp;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>החברה עושה שימוש בממשקים ובתוכנה אשר הינם בעלי הרשאה לעשות בהם
							שימוש לצורך תפעול המערכת ואספקת השירותים.&nbsp;</span
						>
					</li>
				</ol>
				<li
					style="font-weight: 400"
					class="pt-3"
				>
					<strong>זכות גישה למידע הנאסף באתר ובמערכת ונשמר במאגר המידע</strong
					><strong>:</strong><span style="font-weight: 400">&nbsp;</span>
				</li>

				<ol>
					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>בהתאם לחוק הגנת הפרטיות, התשמ"א-1981 (</span
						><strong>"החוק"</strong
						><span style="font-weight: 400"
							>) למשתמשים עומדת הזכות לבקש גישה לנתונים האישיים ולמידע שהאתר
							והאפליקציה אוספים אודותיהם.&nbsp;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>כל אדם זכאי לעיין במידע שעליו המוחזק במאגר מידע. ולכן, למשתמשים
							עומדת הזכות לבקש מהחברה</span
						>
						<span style="font-weight: 400"
							>לתקן או לעדכן את הנתונים האישיים שלהם כאשר הם אינם מדויקים או לא
							שלמים והזכות לבקש מהחברה למחוק את הנתונים האישיים של
							המשתמש.&nbsp;</span
						>
					</li>

					<li>
						<span style="font-weight: 400"
							>פנייה כזאת יש להפנות אל כתובת הדוא"ל </span
						><span style="font-weight: 400">&nbsp;</span>
						<strong
							><a href="mailto:support@my-cliniq.com"
								>support&#64;my-cliniq.com</a
							></strong
						><span style="font-weight: 400">.&nbsp;</span>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>בנוסף, אם המידע שבמאגרי החברה משמש לצורך פניה אישית אליך, אתה
							זכאי על-פי חוק הגנת הפרטיות לדרוש בכתב שהמידע המתייחס אליך יימחק
							ממאגר המידע, וזאת אלא אם החברה נדרשת לשמור את המידע על פי
							חוק.&nbsp;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>החברה מיישמת באתריה ובשרתיה מערכות ונהלים עדכניים לאבטחת מידע.
							בעוד שמערכות ונהלים אלה מצמצמים את הסיכונים לחדירה בלתי-מורשית,
							אין הם מעניקים בטחון מוחלט. לכן, החברה לא מתחייבת שהפלטפורמה תהיה
							חסינה באופן</span
						>
						<span style="font-weight: 400"
							>מוחלט מפני גישה בלתי-מורשית למידע המאוחסן בה</span
						><span style="font-weight: 400">.&nbsp;&nbsp;&nbsp;</span>
					</li>
				</ol>

				<li
					style="font-weight: 400"
					class="pt-3"
				>
					<strong>Cookies:</strong><span style="font-weight: 400">&nbsp;</span>
				</li>

				<ol>
					<li style="font-weight: 400">
						<span style="font-weight: 400">האתר והמערכת משתמשים ב"עוגיות</span
						><span style="font-weight: 400">" (Cookies) </span
						><span style="font-weight: 400"
							>לצורך תפעולם השוטף והתקין, ובכלל זה כדי לאסוף נתונים סטטיסטיים
							אודות השימוש באתר ובמערכת, לאימות פרטים, כדי להתאים את האתר</span
						>
						<span style="font-weight: 400"
							>והאםליקציה להעדפות המשתמש האישיות ולצורכי אבטחת מידע. 'עוגיות" הן
							קבצי טקסט, שהדפדפן יוצר לפי פקודה ממחשבי החברה. העוגיות מכילות
							מידע מגוון כדוגמת הדפים שבהם ביקר המשתמש, משך הזמן ששהה באתר ו/או
							במערכת, מהיכן הגיע אל האתר ועוד. הן משמשות גם כדי לייתר את הצורך
							בהזנת פרטים בכל פעם שהמשתמש מבקר מחדש במדורים באתר המחייבים רישום,
							ככל שישנם כאלה</span
						><span style="font-weight: 400">.&nbsp;</span>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>המשתמש רשאי, בכל עת, לנקות את ה"עוגיות" מן הדפדפן או להגדירו כך
							שיסרב להשתמש ב"עוגיות".&nbsp;</span
						>
					</li>
				</ol>

				<li
					style="font-weight: 400"
					class="pt-3"
				>
					<strong>שינויים במדיניות הפרטיות:</strong
					><span style="font-weight: 400">&nbsp;</span>
				</li>

				<ol>
					<li style="font-weight: 400">
						<span style="font-weight: 400">האתר ו/או המערכת</span>
						<span style="font-weight: 400"
							>שומרים על זכותם לשנות, בכל עת וללא הודעה מוקדמת את מדיניות פרטיות
							זו ושינויים אלו ייכנסו לתוקפם מיד עם הכנסתם למדיניות
							הפרטיות.&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400"
							>במקרה של שינוי מהותי במדיניות הפרטיות, האתר ו/או המערכת</span
						>
						<span style="font-weight: 400"
							>תודיע על כך למשתמשים באמצעות פרסום הודעה בולטת באתר ו/או במערכת.
							במקרה שהאתר ו/או המערכת</span
						>
						<span style="font-weight: 400"
							>יבקשו להחיל שינוי מהותי זה גם על מידע שכבר נאסף באתר ו/או במערכת,
							תישלח הודעה למשתמש במטרה לבקש את הסכמתו לכך.&nbsp;&nbsp;</span
						>
					</li>

					<li style="font-weight: 400">
						<span style="font-weight: 400">האתר והמערכת</span>
						<span style="font-weight: 400"
							>ממליצים למשתמשים לעיין במדיניות פרטיות זו מעת לעת על מנת לקבל
							מידע על האופן שבו האתר ו/או המערכת</span
						>
						<span style="font-weight: 400">מגנים על המידע שלהם.&nbsp;</span>
					</li>
				</ol>

				<li
					style="font-weight: 400"
					class="pt-3"
				>
					<strong>יצירת קשר</strong><strong>:</strong
					><span style="font-weight: 400">&nbsp;</span>
				</li>

				<ol>
					<li style="font-weight: 400">
						<span style="font-weight: 400">האתר והמערכת</span>
						<span style="font-weight: 400"
							>מקפידים על קיום הוראות החוק ומכבדת את זכותם של משתמשי האתר
							והמערכת ואחרים לפרטיות. אם אתה סבור כי פרטיותך נפגעה באופן כלשהו,
							אנא פנה אלינו לפי הפרטים שלהלן ואנו נשתדל לטפל בפנייתך בכל ההקדם.
							פניות כאמור ניתן להעביר באמצעים הבאים:&nbsp;</span
						>
					</li>
				</ol>
				<div class="pt-3">
					<span style="font-weight: 400">טלפון: &nbsp; </span
					><strong>0544-2-444-08</strong
					><span style="font-weight: 400">&nbsp;</span>
				</div>
				<div>
					<span style="font-weight: 400">או דוא"ל שכתובתו: &nbsp; </span>
					<strong
						><a href="mailto:support@my-cliniq.com"
							>support&#64;my-cliniq.com</a
						></strong
					><span style="font-weight: 400">&nbsp;</span>
				</div>
			</ol>
			<div>&nbsp;</div>
			<div>
				<span style="font-weight: 400"
					>* מסמך זה מנוסח בלשון זכר, אך הכוונה לגברים ולנשים כאחד.</span
				>
			</div>
			<div>&nbsp;</div>
			<div>
				<span style="font-weight: 400">עדכון אחרון: דצמבר 2025&nbsp;</span>
			</div>
			<div
				class="pt-3"
				style="font-size: 10px"
			>
				<strong
					>&copy; מסמך זה ותוכנו הם זכויות יוצרים של חברת די אן איי בע"מ - כל
					הפצה או העתקה, כולו או חלקו, בכל צורה שהיא, אסורה</strong
				><span style="font-weight: 400">&nbsp;</span>
			</div>

			<br />
		</div>
	`,
})
export class PrivacyComponent {}
